const state = {
  isConnected: false,
}

const getters = {}

const actions = {
  connect({ state, dispatch }) {
    if (state.isConnected === true) {
      console.log("already connected to ws")
      return
    }

    this._vm.$socket.local.connect()
  },

  wsppt_connect({ commit, dispatch }) {
    commit("setIsConnected", true)
    dispatch("getPilot")
    dispatch("getEvent")
    dispatch("getCurrentContentApp")
  },

  "wsppt_powerpoint:run"({ dispatch }, { user, token }) {
    dispatch("pilot/setPilot", { user, token }, { root: true })
  },

  getPilot({ dispatch }) {
    this._vm.$socket.local.emit("powerpoint:user", null, ({ user, token }) => {
      dispatch("pilot/setPilot", { user, token }, { root: true })
    })
  },

  "wsppt_powerpoint:event:change"({ dispatch }, { event_guid }) {
    if (event_guid !== null && event_guid !== "") {
      dispatch("pilot/setEvent", { event_guid }, { root: true })
    }
  },

  getEvent({ dispatch }) {
    this._vm.$socket.local.emit("powerpoint:event", null, ({ event_guid, error }) => {
      if (event_guid !== null && event_guid !== "" && error === undefined) {
        dispatch("pilot/setEvent", { event_guid }, { root: true })
      }
    })
  },

  getCurrentContentApp({ dispatch }) {
    this._vm.$socket.local.emit("powerpoint:current_content_app", null, ({ currentContentApp }) => {
      dispatch("app/initStore", currentContentApp, { root: true })
    })
  },

  alert({ state }, message) {
    this._vm.$socket.local.emit("powerpoint:alert", { message: message })
  },

  bounce({ state, rootState, rootGetters }, message) {
    const bounceAnswers = []
    rootState.answers.selected.map((id) => {
      const answer = rootState.answers.all[rootState.answers.order[id]]
      const label = rootGetters["labels/getLabel"](answer.question_labels_guid_text)
      bounceAnswers.push({
        number: answer.number,
        text: answer.text,
        likes_count: answer.likes_count,
        label: label.text,
      })
    })
    this._vm.$socket.local.emit("powerpoint:bounce", { answers: bounceAnswers })
  },
}

const mutations = {
  setIsConnected(state, value) {
    state.isConnected = value
    console.log("connected to wsppt")
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
